import React from 'react';
import { Redirect, useLocation } from 'react-router';

/** Preserves query/hash when normalizing retired ATS aliases. */
export function RedirectCandidatesToLegacy() {
  const { search, hash } = useLocation();
  return <Redirect to={{ pathname: '/manage-candidates', search, hash }} />;
}

export function RedirectApplicationHistoryToLegacy() {
  const { search, hash } = useLocation();
  return <Redirect to={{ pathname: '/application-history', search, hash }} />;
}
